// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"105":"5cfca644","140":"2432a69e","453":"fa59c633"}[chunkId] + ".chunk.js";
};